import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import axios from 'axios';
import PreviewIcon from '@mui/icons-material/Preview';


const KajeInwView = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: '',
        kjMemo: '',
        sreMemo: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totQty: '',
        instruction: '',
        firmId: ''
    });
    const [tableData, setTableData] = useState([]);
    const { Id } = useParams();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        fetchKajeInwData(Id);
    }, [Id]);


    const fetchKajeInwData = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getKajeReturnRegister&kinwId=${id}`);
            const res = response?.data?.data;
            // console.log(res);
            setFormData(prev => ({
                ...prev,
                dt: res?.dt,
                empId: res?.empId,
                empNm: res?.empNm,
                firmId: res?.firmId,
                firmNm: res?.firmNm,
                inwqty: res?.inwqty,
                itemId: res?.itemId,
                itemNm: res?.itemNm,
                kjMemo: res?.kjMemo,
                kreMemo: res?.kreMemo,
                mcloth: res?.mcloth,
                mclothNm: res?.mclothNm,
                m1cloth: res?.m1cloth,
                m1clothNm: res?.m1clothNm,
                m2cloth: res?.m2cloth,
                m2clothNm: res?.m2clothNm,
                m3cloth: res?.m3cloth,
                m3clothNm: res?.m3clothNm,
                soId: res?.soId,
                sono: res?.sono,
                totqty: res?.totqty
            }));
            setTableData(response?.data?.info);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleViewClick = (id, info) => {
        window.open(`/ClothIssueLumpsView/${id}-${info}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Kaje Inward View - ({formData.kreMemo})</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Kaje Inward Memo No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.kreMemo}</td>

                                </tr>


                                {formData.soId !== '0' &&

                                    <tr>
                                        <td style={{ width: '200px' }}>Sale Order No.</td>

                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>

                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    {/* <td style={{ width: '200px' }}>Total Issue Qty.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totqty}</td> */}

                                    <td style={{ width: '200px' }}>Total Inward Qty.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.inwqty}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>

                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>
                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }
                            </tbody>

                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Return Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(tableData) && tableData.length > 0 ? (
                                        tableData?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rqty}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default KajeInwView;
